import type { GetStaticProps } from 'next'

import { WordPressApiClient } from '@/utils/WordPressApiClient'

export { ReleasePage as default } from '@/components/enpages/News/Release'

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const [newsRelease, tagList] = await Promise.all([
    wpClient.fetchNewsRelease(),
    wpClient.fetchNewsReleaseTag(),
  ])

  const displayTagList = tagList.filter((tag) =>
    newsRelease.some((news) => news.tag.some(({ _id }) => _id === tag._id))
  )

  return {
    props: {
      newsRelease,
      tagList: displayTagList,
    },
  }
}
